export const clients = [
  "client.jpg",
  "client.png",
  "client1.png",
  "client2.png",
  "client3.png",
  "client4.png",
  "client5.png",
  "client6.png",
  "client7.png",
  "client8.png",
  "client9.png",
  "client10.png",
  "client11.png",
  "client12.png",
  "client13.png",
  "client14.png",
  "client15.png",
  "client16.png",
  "client17.png",
  "client18.png",
  "client19.jpg",
  "client20.png",
  "client21.png",
  "client22.png",
];
